<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventory.operation.stock_transfer.stock_transfer') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('inventory.operation.stock_transfer.stock_transfer'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-5">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'stock-transfer-create-v2' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-4 d-flex justify-content-end">
            <div class="btn-group btn-group-justified">
              <a
                class="btn btn-default"
                :class="transfered"
                @click.prevent="transfere"
              >
                {{ $t('inventory.operation.stock_transfer.transfered') }}
              </a>
              <a
                class="btn btn-default"
                :class="recieved"
                @click.prevent="recieve"
              >
                {{ $t('inventory.operation.stock_transfer.recieved') }}
              </a>
            </div>
          </div>
          <div class="col-sm-12 col-md-3 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'transfer_date'
          }"
        >
          <template v-slot="{ record }">
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.trans_number }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.branch_name_en }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.location_name }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.transferred_by_name }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.to_branch_name_en }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.to_location_name }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.received_by_name }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              <span :class="statusStyle(record.transfer_status_id)">{{
                status(record.transfer_status_id)
              }}</span>
            </td>
            <td
              class="ts-whitespace-no-wrap text-center"
              :style="rowStyle(record.transfer_status_id)"
            >
              $ {{ format_number(record.total_amount) }}
            </td>
            <td
              class="ts-whitespace-no-wrap text-center"
              :style="rowStyle(record.transfer_status_id)"
            >
              <a
                href="#"
                v-tooltip="$t('view')"
                class="text-info"
                @click.prevent="view(record)"
              >
                <i class="fas fa-eye"></i>
              </a>

              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="ml-2 text-danger"
                @click.prevent="pdfView(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <span v-if="record.transfer_status_id == 1">
                <a
                  v-if="transfer_type === 'recieved'"
                  href="#"
                  v-tooltip="'Confirm'"
                  class="ml-2 mr-2 text-success"
                  @click.prevent="confirm(record)"
                >
                  <i class="far fa-check-circle"></i>
                </a>
                <a
                  v-if="transfer_type === 'recieved'"
                  href="#"
                  v-tooltip="'Reject'"
                  class="text-warning"
                  @click.prevent="reject(record)"
                >
                  <i class="far fa-times-circle"></i>
                </a>
                <a
                  v-if="transfer_type === 'transfered'"
                  href="#"
                  v-tooltip="$t('edit')"
                  class="mr-2 ml-2 text-primary"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  v-if="transfer_type === 'transfered'"
                  href="#"
                  v-tooltip="$t('delete')"
                  class="text-danger"
                  @click.prevent="destroy(record)"
                  :disabled="record._deleting"
                >
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fas fa-trash" v-else></i>
                </a>
              </span>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <ts-branch-filter @filter="value => (branch_id = value)" />
          </div>
        </div>
      </div>
    </a-drawer>
    <pdf-preview
      v-model="pdf_view"
      :stock-transfer-id="stockTransferId"
      @cancel="value => (pdf_view = value)"
    />
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import DetailsComponent from './details'
import PdfPreview from './component/pdf_preview'
export default {
  name: 'stock-transfer',
  components: {
    PdfPreview
  },
  data() {
    return {
      loading: false,
      transfered: 'active',
      recieved: '',
      visible: false,
      branch_id: [],
      pdf_view: false,
      stockTransferId: 0
    }
  },
  computed: {
    ...mapState('stockTransfer', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.stockTransfer.search
      },
      set(newValue) {
        this.$store.commit('stockTransfer/SET_SEARCH', newValue)
        this.$store.commit('stockTransfer/RESET_CURRENT_PAGE')
      }
    },
    transfer_type: {
      get() {
        return this.$store.state.stockTransfer.transfer_type
      },
      set(val) {
        this.$store.commit('stockTransfer/SET_TRANSFER_TYPE', val)
      }
    },
    columns() {
      return [
        { name: this.$t('inventory.operation.stock_transfer.transfer') },
        { name: this.$t('inventory.operation.stock_transfer.from_branch') },
        { name: this.$t('inventory.operation.stock_transfer.from_location') },
        { name: this.$t('inventory.operation.stock_transfer.transfered_by') },
        { name: this.$t('inventory.operation.stock_transfer.to_branch') },
        { name: this.$t('inventory.operation.stock_transfer.to_location') },
        { name: this.$t('inventory.operation.stock_transfer.recieved_by') },
        { name: this.$t('inventory.operation.stock_transfer.status') },
        {
          name: this.$t('inventory.operation.stock_transfer.total_amount'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('inventory.operation.stock_transfer.actions'),
          style: 'text-align:center; width:2%'
        }
      ]
    },
    rowStyle: () => status => {
      let color = ''

      switch (status) {
        case 1:
          color = ''
          break
        case 2:
          color = ''
          break
        case 3:
          color = '#90949c'
          break
      }

      return {
        color: color
      }
    },
    statusStyle: () => status => {
      let badge = ''

      switch (status) {
        case 1:
          badge = 'badge badge-info'
          break
        case 2:
          badge = 'badge badge-primary'
          break
        case 3:
          badge = 'badge badge-default'
          break
      }

      return badge
    },
    status: () => status => {
      let value = ''

      switch (status) {
        case 1:
          value = 'Pending'
          break
        case 2:
          value = 'Recieved'
          break
        case 3:
          value = 'Rejected'
          break
      }

      return value
    }
  },
  created() {
    this.transfer_type = 'transfered'
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'stockTransfer/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('stockTransfer/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'stock-transfer-edit',
        params: { id: record.stock_transfer_id }
      })
    },
    transfere() {
      this.transfer_type = 'transfered'
      this.transfered = 'active'
      this.recieved = ''
    },
    recieve() {
      this.transfer_type = 'recieved'
      this.recieved = 'active'
      this.transfered = ''
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('stockTransfer/destroy', record.stock_transfer_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            if (
              error.message ===
              'The current user not yet belong to any warehouses.'
            ) {
              this.$toasted.info(error.message)
            } else {
              this.$toasted.error(error.message)
            }
            record._deleting = false
          })
      }
    },
    async confirm(record) {
      if (
        await this.$confirmModal(
          this.$t('inventory.operation.stock_transfer.are_you_sure_to_confirm')
        )
      ) {
        record._deleting = true
        this.$store
          .dispatch('stockTransfer/confirm', {
            stock_transfer_id: record.stock_transfer_id,
            transfer_status_id: 2
          })
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            if (
              error.message ===
                'The current user not yet belong to any warehouses.' ||
              error.message ===
                'Transferred and recieved user must be defferent.'
            ) {
              this.$toasted.info(error.message)
            } else {
              this.$toasted.error(error.message)
            }
            record._deleting = false
          })
      }
    },
    async reject(record) {
      if (
        await this.$confirmModal.danger(
          this.$t('inventory.operation.stock_transfer.are_you_sure_to_reject')
        )
      ) {
        record._deleting = true
        this.$store
          .dispatch('stockTransfer/reject', {
            stock_transfer_id: record.stock_transfer_id,
            transfer_status_id: 3
          })
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            if (
              error.message ===
                'The current user not yet belong to any warehouses.' ||
              error.message ===
                'Transferred and recieved user must be defferent.'
            ) {
              this.$toasted.info(error.message)
            } else {
              this.$toasted.error(error.message)
            }
            record._deleting = false
          })
      }
    },
    view(data) {
      this.$modal.show(
        DetailsComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },

    pdfView(record) {
      // add
      this.stockTransferId = record.stock_transfer_id
      this.pdf_view = true
    },

    format_number(value) {
      return parseFloat(value).toFixed(2)
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    transfer_type: function(data) {
      this.$store.commit('stockTransfer/RESET_STATE')
      this.fetchData()
    },
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'stock-transfer-create') {
      this.$store.commit('stockTransfer/RESET_STATE')
    }
    next()
  }
}
</script>
